import React, { useMemo } from 'react';
import { Field, useForm, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import DatepickerField from 'components/DatepickerField';
import CheckboxFieldGroup from 'components/CheckboxFieldGroup';
import SelectField from 'components/SelectField';
import { timeOptions } from 'data/timeOptions';
import { getTimeFromUserTimezone } from 'utils';
import {
  getIsStartOfDayToday,
  getTimeOptionsAboveHour,
  getYesterday,
} from 'dateUtils';
import ResolvePopup from 'components/ResolvePopup';
import InformationcircleIcon from 'icons/Informationcircle.icon';
import { useRfi } from 'hooks/useRfi';
import { RfiCreateStep } from 'router/subrouters/DataRoom/models/DataRoomRfi';

import './StepSettings.styles.scss';

const StepSettings: React.FC<RfiCreateStep> = ({
  isCreatingOrEditingTemplate,
}) => {
  const { t } = useTranslation();

  const yesterday = getYesterday();

  const {
    values: { dueDate },
  } = useFormState();
  const { change } = useForm();

  const dueTimeOptions = useMemo(() => {
    if (dueDate && getIsStartOfDayToday(dueDate)) {
      const { hours } = getTimeFromUserTimezone(new Date().toISOString());

      return getTimeOptionsAboveHour(hours);
    }

    return timeOptions;
  }, [dueDate]);

  const { notificationMediumOptions, getDueDateReminderOptions } = useRfi();

  const RenderCheckboxes = useMemo(
    () => getDueDateReminderOptions(!dueDate),
    [dueDate, getDueDateReminderOptions],
  );

  return (
    <>
      <div className="step-settings">
        <p>{t('notifyMeAboutRequestUpdates')}</p>

        <div>
          <CheckboxFieldGroup
            name="notificationMedium"
            options={notificationMediumOptions}
          />
        </div>
      </div>

      {isCreatingOrEditingTemplate ? null : (
        <div className="step-settings__dates">
          <div>
            <Field
              name="dueDate"
              label={t('specifyDueDate')}
              minDate={yesterday}
              component={DatepickerField}
              customOnChange={() => {
                change('dueTime', undefined);
              }}
            />
            <Field
              name="dueTime"
              component={SelectField}
              label={t('time')}
              disabled={!dueDate}
              options={dueTimeOptions}
            />
          </div>
          <p>{t('rfiDueDateDescription')}</p>

          <div className="notify">
            <div className="title">
              {t('dueDateRemindersFrequency')}
              <ResolvePopup
                onHover
                popupContent={t('remindersWillBeSentUntilUploaded')}
              >
                <InformationcircleIcon />
              </ResolvePopup>
            </div>

            <div className="options">{RenderCheckboxes} </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StepSettings;
